import styled from 'styled-components';

export const TextWidgetSection = styled.section`
  margin: 30px 0;
  padding: ${(props) => (props.padding ? '20px 7.5%' : '0 7.5%')};
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );
  @media (max-width: 720px) {
    padding: 0;
  }
`;
export const TextWidgetContent = styled.div`
  padding: 20px 0;
  font-weight: 500;
  color: rgb(0 0 0 / 80%);
  line-height: 1.7;
  font-size: clamp(14px, 2vw, 16px);
`;
